<div class="fluid" style="padding-top: 90px;">
  <div class="row">
    <div class="col-sm-6 padding-hero" style=" padding-bottom: 80px;">
      <img class="img-content-deliveryjoy img-fluid" src="assets/img/Hero - Slogan.png" />
      <div class="text-content-deliveryjoy padding-text-hero">
        Nikmati berbagai kemudahan untuk kebutuhan bisnis Anda dimanapun
        kapanpun dengan Sukanda Onelink.
      </div>
      <div>
        <button style="display:none" class="button-content-deliveryjoy" onclick="document.location='https://buyer.sukandaonelink.com/aktivasi'">
          <p style="
              font-size: 14px;
              letter-spacing: 0.3px;
              height: 18px;
              left: 16px;
              right: 17px;
              top: calc(50% - 18px / 2);
              margin-top: 10px;
            ">
            Daftar Sekarang
          </p>
        </button>
        <button class="button-content-deliveryjoy" onclick="document.location='https://buyer.sukandaonelink.com/aktivasi'">
          <p style="
              font-size: 14px;
              letter-spacing: 0.3px;
              height: 18px;
              left: 16px;
              right: 17px;
              top: calc(50% - 18px / 2);
              margin-top: 10px;
            ">
            Aktifasi
          </p>
        </button>
      </div>
    </div>
    <div class="col-sm-6" style="
        background-color: transparent;
        padding-left: 53px;
      ">
      <img class="img-content-walpaper img-fluid" src="assets/img/Group 1784.png" />
    </div>
  </div>
</div>

<div class="fluid slide-padding">
  <div class="card-deck ">
    <div class="slider" style="width: 100%;">
      <div class="slide-track">
        <div class="slide img-slide">
          <img src="assets/img/item1.png" height="88px" width="173px" style="border-radius: 10px;" alt="" />
        </div>
        <div class="slide img-slide">
          <img src="assets/img/item2.png" height="88px" width="173px" style="border-radius: 10px;" alt="" />
        </div>
        <div class="slide img-slide">
          <img src="assets/img/item3.png" height="88px" width="173px" style="border-radius: 10px;" alt="" />
        </div>
        <div class="slide img-slide">
          <img src="assets/img/item4.png" height="88px" width="173px" style="border-radius: 10px;" alt="" />
        </div>
        <div class="slide img-slide">
          <img src="assets/img/item5.png" height="88px" width="173px" style="border-radius: 10px;" alt="" />
        </div>
        <div class="slide img-slide">
          <img src="assets/img/item6.png" height="88px" width="173px" style="border-radius: 10px;" alt="" />
        </div>
        <div class="slide img-slide">
          <img src="assets/img/item7.png" height="88px" width="173px" style="border-radius: 10px;" alt="" />
        </div>
        <div class="slide img-slide">
          <img src="assets/img/item8.png" height="88px" width="173px" style="border-radius: 10px;" alt="" />
        </div>
        <div class="slide img-slide">
          <img src="assets/img/item9.png" height="88px" width="173px" style="border-radius: 10px;" alt="" />
        </div>
        <div class="slide img-slide">
          <img src="assets/img/item10.png" height="88px" width="173px" style="border-radius: 10px;" alt="" />
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <ngx-slick-carousel class="carousel"
  #slickModal="slick-carousel"
  [config]="slideConfig"
  (init)="slickInit($event)"
  (breakpoint)="breakpoint($event)"
  (afterChange)="afterChange($event)"
  (beforeChange)="beforeChange($event)">
<div ngxSlickItem *ngFor="let slide of slides" class="slide">
<img src="{{ slide.img }}" alt="" width="173pxpx" height="88px">
</div>
</ngx-slick-carousel> -->



<div id="tentang-kami">
  <div style="margin-top: 88px;margin-bottom: 24px;">
    <img class="mx-auto d-block" src="assets/img/sol-logo.png" width="120px" height="100px" />
  </div>
  <div class="col-sm-12">
    <p class="text-kett">

      Platform B2B Online untuk memudahkan Anda
    </p>
    <p class="text-ket">
      mengakses semua informasi produk
      dan pemesanan produk dimanapun, kapanpun.
    </p>
  </div>
  <div style="margin-top: 40px;"></div>
  <div class="row row-pross">
    <div class="col-sm-3">
      <img class="mx-auto d-block" src="assets/img/Book_open.png" />
      <p class="text-ket2">Katalog Online</p>
      <p class="text-ket3">
        Temukan seluruh produk kami dengan lebih mudah.
      </p>
    </div>
    <div class="col-sm-3">
      <img class="mx-auto d-block" src="assets/img/Gps_fixed.png" />
      <p class="text-ket2">Cek Status Pesanan</p>
      <p class="text-ket3">
        Dapatkan informasi status pesanan langsung di platform kami.
      </p>
    </div>

    <div class="col-sm-3">
      <img class="mx-auto d-block" src="assets/img/File_dock.png" />
      <p class="text-ket2">Invoice Digital</p>
      <p class="text-ket3">
        Download invoice langsung dari Sukanda Onelink.
      </p>
    </div>

    <div class="col-sm-3">
      <img class="mx-auto d-block" src="assets/img/History_Icon.png" />
      <p class="text-ket2">Histori Pesanan</p>
      <p class="text-ket3">
        Akses dan pesan ulang dari histori pemesanan Anda.
      </p>
    </div>
  </div>
  <div id="info" class="calrousel slide carousel-position" data-ride="carousel">
    <div id="demo" class="carousel slide carousel-position" data-ride="carousel">
      <!-- Indicators -->
      <ul class="carousel-indicators">
        <li data-target="#demo" data-slide-to="0" class="active"></li>
        <li data-target="#demo" data-slide-to="1"></li>
        <li data-target="#demo" data-slide-to="2"></li>
      </ul>

      <!-- The slideshow -->
      <div class="carousel-inner">
        <!-- <div class="carousel-item">
            <div class="row align-items-center">
              <div class="col-sm-5">
                <img
                  src="assets/img/bgSlide.png"
                  alt="Los Angeles"
                  style="
                    margin-left: 25px;
                    width: 540px;
                    height: 350px;
                    border-radius: 20px;
                  "
                />
              </div>
              <div class="col-md py-2">
                <img
                  src="assets/img/quote.png"
                  alt="Los Angeles"
                  style="margin-left: 90px; width: 540px; height: 310px;"
                />
              </div>
            </div>
          </div> -->
        <div class="carousel-item active">
          <div class="row align-items-center">
            <div class="col-sm-5">
              <img src="assets/img/carousel_cust2.jpeg" alt="Los Angeles" class="img-fluid img-carousel-testimony" />
            </div>
            <div class="col-md py-2" style="margin-top: 24px;">
              <!-- <img src="assets/img/quote2.png" alt="Los Angeles" class="img-content-carousel" /> -->
              <img src="assets/img/quote icon.png" class="img-review" />
              <br />
              <p class="content-review">
                Semenjak ada fitur Sukanda OneLink dari Sukanda Djaya. Proses order, pencarian barang, dan masalah
                teknis lainnya jd simple bgt. Semua masalah di bagian Purchasing menjadi _"Happy Problem" _
              </p>
              <br />
              <p class="cust-review">
                Igor - Sedjuk Bakmi
              </p>
            </div>
          </div>
        </div>
        <!-- <div class="carousel-item">
            <div class="row align-items-center">
              <div class="col-md py-2">
                <img
                  src="assets/img/banner2.jpeg"
                  alt="Chicago"
                  style="margin-left: 123px;width: 540px;
                  height: 350px;"
                />
              </div>
              <div class="col-md py-2">
                <div
                  style="
                    margin-top: 110px;
                    margin-left: 110px;
                    font-size: 16px;
                    color: #737b7d;
                    margin-right: 120px;
                  "
                >
                  Et has minim elitr intellegat. Mea aeterno eleifend antiopam
                  ad, nam no suscipit quaerendum. At nam minimum ponderum. Est
                  audiam animal molestiae te. Ex duo eripuit mentitum.
                </div>
              </div>
            </div>
          </div> -->
      </div>

      <!-- Left and right controls -->
      <a class="carousel-control-prev" href="#demo" data-slide="prev">
        <span class="carousel-control-prev-icon" style="margin-left: -145px;"></span>
      </a>
      <a class="carousel-control-next" href="#demo" data-slide="next">
        <span class="carousel-control-next-icon" style="margin-left: 140px;"></span>
      </a>
    </div>
  </div>
</div>

<div class="container-fluid bgx5">
  <br>

  <p class="txt-sol">
    Siap Gabung Sukanda Onelink?
  </p>
  <br>
  <div class="row">
    <div class="col-sm-6 bg-left">
      <p class="text-left-a"> Gabung dan nikmati segala kemudahan di Sukanda Onelink.</p>
      <button type="button" class="btn button-register-now-left" onclick="document.location='https://buyer.sukandaonelink.com/aktivasi'">Daftar Sekarang</button>
      <p class="space"></p>
      <img class="img-fluid" width="570px" height="285px" src="assets/img/desktop.png" />
    </div>
    <div class="col-sm-6 bg-right">
      <p class="text-right-a"> Akses fitur terbaik Sukanda Onelink untuk bisnis di smartphone Anda. Download sekarang
        di Appstore & Playstore</p>
      <br>
      <a href="https://play.google.com/store/apps/details?id=com.sukanda.onelink">
        <img class="logo-img-x forminlinemargin" src="assets/img/playstore logo.png"
          style="width: 165.18px; height: 49.28px;" />
      </a>
      <a href="https://apps.apple.com/id/app/sukanda-onelink/id1544732426?l=id">
        <img class="logo-img-x forminlinemargin" src="assets/img/appstore logo.png"
          style="width: 165.18px; height: 49.28px;" />
      </a>
      <img class="img-fluid img-right" style="margin-top: 66.86px" width="403px" height="287px"
        src="assets/img/phone.png" />

    </div>
  </div>
</div>

<!-- <div style="
      background: #0b0b57;
      position: absolute;
      height: 616px;
      width: 1440px;
    ">
    <p style="
        width: 1290px;
        height: 52px;
        left: calc(50% - 920px / 2);
        top: 34px;
        font-style: normal;
        font-weight: 500;
        font-size: 40px;
        line-height: 130%;
        text-align: center;
        letter-spacing: 0.7px;
        color: #fcfcfc;
        margin-top: 30px;
      ">
      Siap Gabung Sukanda Onelink?
    </p>
  </div>
  <br />
  <br />
  <div class="row" style="
      background-color: #0b0b57;
      margin-top: 73px;
      height: 495px;
      width: 1440px;
    ">
    <div class="col-sm-6" style="
        width: 643px;
        height: 495px;
        background-size: cover;
        position: relative;
        padding-top: 15 em;
        background-image: url(../../assets/img/image-webcontent.png);
        background-color: white;
      ">
      <div style="
          margin-top: 50px;
          width: 565px;
          height: 44px;
          left: calc(50% - 445px / 2 + 5.5px);
          top: 66px;


          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          line-height: 22px;

          /* or 137% */
          text-align: center;
          letter-spacing: 0.3px;
          padding-right: 292px;
          margin-left: 187px;
          color: #ffffff;
        ">
        Gabung dan nikmati segala kemudahan di Sukanda Onelink.
      </div>
      <br />
      <div style="margin-left: 235px;">
        <button style="
            background-color: #fcfcfc;
            color: #3c64b1;
            position: static;
            width: 156px;
            height: 48px;
            right: 0px;
            top: calc(50% - 42px / 2);
            border: none;
            box-shadow: 4px 8px 24px rgba(0, 0, 0, 0.1);
            border-radius: 8px;
          " onclick="document.location='https://buyer.sukandaonelink.com/aktivasi'">
          <p style="

              font-style: normal;
              font-weight: 500;
              line-height: 18px;
              font-size: 14px;
              align-items: center;
              text-align: center;
              letter-spacing: 0.3px;
              height: 18px;
              left: 16px;
              right: 17px;
              top: calc(50% - 18px / 2);
              margin-top: 10px;
            ">
            Daftar Sekarang
          </p>
        </button>
      </div>
      <div style="margin-top: 37px; margin-left: 23px;">
        <img class="logo-img-x" src="assets/img/desktop.png" style="width: 570px; height: 292px;" />
      </div>
    </div>
    <div class="col-sm-6" style="
        background-image: url(../../assets/img/content.png);
        width: 643px;
        height: 495px;
        background-size: cover;
        position: relative;
        padding-top: 15 em;
      ">
      <div style="
          margin-top: 50px;
          font-size: 16px;
          color: #737b7d;
          margin-left: 82px;
          text-align: center;


          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          line-height: 22px;
        ">
        Akses fitur terbaik Sukanda Onelink untuk bisnis di smartphone Anda.
        Download sekarang di Appstore & Playstore.
      </div>
      <div style="margin-left: 184px; margin-top: 15px;">
        <a href="https://play.google.com/store/apps/details?id=com.sukanda.onelink">
          <img class="logo-img-x forminlinemargin" src="assets/img/playstore logo.png"
            style="width: 165.18px; height: 49.28px;" />
        </a>
        <a href="https://apps.apple.com/id/app/sukanda-onelink/id1544732426?l=id">
          <img class="logo-img-x forminlinemargin" src="assets/img/appstore logo.png"
            style="width: 165.18px; height: 49.28px;" />
        </a>
      </div>
      <div style="margin-left: 130px; margin-top: 31px;">
        <img class="logo-img-x forminlinemargin" src="assets/img/phone.png" style="width: 403px; height: 287px;" />
      </div>
    </div>
  </div>-->
